module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAMAAABBexbDAAAAjVBMVEUAAABVqlVmmTN2nTuAn0CAqjl0ojp8oDp8ozt5pD16ojp5pDh6pTt4pDp5pDl5pDp4pDt6ojp6pDl6pDp4ozp4pDp6ozt5ojp4ozp5ojl5ojp5pDt5ojp4ozp5pDt6ozp4ozp5ozp5ozp5ozp5ozp5ozp5ojp5ozp5ozp5ozp5ozp5ozp5ozp5ozr///8yQvfrAAAALXRSTlMAAwUNEBIWIycqLDtBRkxUV1haXGZqdXZ3gZKUmrS71trb3OXq7O3u7/L5+vxdXR0bAAAAAWJLR0QuVNMQhwAAAHFJREFUGNOlyMkSwWAUBeE2RowxEyTmQ7jv/3oWf4UbVVa+XTcEcRZTMbjZfejH7GFmz9W7a6kF23oYjZ2VsiZAlNvHoQO9s3nXPoVVFdi3v85+3E2O/pxaQPvizhqAjTtTAJbuTABY/DqSpBEAc0nSC7zXJvAaunZAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/menu/icn_home.png
// module id = VtZZ
// module chunks = 1